export const visibleVariants = {
  variants: {
    invisible: {
      true: "oui-invisible",
      //   false: "oui-visible",
    },
  },
};
